import { render, staticRenderFns } from "./ProductChangeLogsTitle.vue?vue&type=template&id=8bc919de&scoped=true"
import script from "./ProductChangeLogsTitle.vue?vue&type=script&lang=js"
export * from "./ProductChangeLogsTitle.vue?vue&type=script&lang=js"
import style0 from "./ProductChangeLogsTitle.vue?vue&type=style&index=0&id=8bc919de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc919de",
  null
  
)

export default component.exports